import StreamOffline from '../../Content/ContentGeneral/StreamOffline'

import { useContext } from 'react'
import { Link } from 'react-router-dom'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'

const Offline = () => {
  return (
    <div className="flex flex-col gap-5">
      <h2>Offline Settings</h2>
      <StreamOffline />
      <OfflineImage />
    </div>
  )
}

const OfflineImage = () => {
  const { [SETTINGS.IMAGES.key]: images } = useContext(SiteConfigContext)

  if (!images?.offline) {
    return (
      <Link to={'/mod/content/assets'}>
        <button className="flex w-full button-fill" type="button">
          Upload an Offline Image
        </button>
      </Link>
    )
  }

  return (
    <div className="flex flex-col gap-5">
      <img src={images.offline} alt="Image" />
      <Link to={'/mod/content/assets'}>
        <button className="flex button-fill w-fit" type="button">
          Edit Image
        </button>
      </Link>
    </div>
  )
}

export default Offline
